import request from "@/utils/request"

const trackConsent = (params) =>
  request.put("/api/consent", {
    body: {
      /* eslint-disable-next-line camelcase */
      cookie_consent: {
        statistics: params.statistics,
        marketing: params.marketing
      }
    },
    token: true
  })

export default {
  trackConsent
}
